import { FC, useContext } from 'react';

import { Button, H2, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { EAdvertisementItem } from '../../pages/Advertisement/interfaces';
import s from './AdvertisementPublishedModal.module.scss';
import { IAdvertisementPublishedModalProps } from './interfaces';

export const AdvertisementPublishedModal: FC<IAdvertisementPublishedModalProps> =
  ({ onClose, setAdvertisementItem }) => {
    const { t } = useContext(LocalizationContext);
    return (
      <Modal className={s.container} onClose={onClose}>
        <H2 className={s.title}>{t('advertisement.published.title')}</H2>
        <span className={s.text}>{t('advertisement.published.text')}</span>
        <div className={s.buttons_block}>
          <Button
            onClick={() => {
              onClose();
              setAdvertisementItem(EAdvertisementItem.PublicAdvertisement);
            }}
            fullWidth
          >
            {t('advertisement.tab.publish')}
          </Button>
          <Button
            onClick={() => {
              onClose();
              setAdvertisementItem(EAdvertisementItem.MyAdvertisement);
            }}
            fullWidth
            variant="secondary"
          >
            {t('advertisement.tab.my')}
          </Button>
        </div>
      </Modal>
    );
  };
